import { useCallback, useState } from "react";
const useLocation = ()=>{
    const [selectedTab, setSelectedTab] = useState(0);
    const [showButton, setShowButton] = useState(false);
    const handleOnMouseDownOrigin = useCallback((e)=>{
        e.preventDefault();
        e.stopPropagation();
        setSelectedTab(0);
        setShowButton(false);
    }, []);
    const handleOnMouseDownDestination = useCallback((e)=>{
        e.preventDefault();
        e.stopPropagation();
        setSelectedTab(1);
        setShowButton(false);
    }, []);
    return {
        selectedTab,
        setSelectedTab,
        showButton,
        setShowButton,
        handleOnMouseDownOrigin,
        handleOnMouseDownDestination
    };
};
export default useLocation;

//# sourceMappingURL=useLocation.js.map